import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AddParamsService, Params } from '../utilis/add-params-service';
import { EmployeeActivity } from '../../models/employee-activity';
import { GenericPaginated } from '../../models/generic-paginated';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmployeeActivityService {

  private baseUrl = environment.url;

  private http = inject(HttpClient);
  private addParamsService = inject(AddParamsService)

  getEmployeeActivityList(params?: Params): Observable<GenericPaginated<EmployeeActivity>> {
    return this.http.get<GenericPaginated<EmployeeActivity>>(`${this.baseUrl}/employee-activities`, {
      params: this.addParamsService.addParams(params)
    });
  }

  exportEmployeeActivity(params?: Params): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/employee-activities/export`, {
      params: this.addParamsService.addParams(params),
      responseType: 'blob'
    });
  }
}
